import React from "react";
import { MdDelete, MdOpenInNew, MdSearch } from "react-icons/md";
import { formatDate } from "../../utils/units";

const SEOHistoryTable = ({ history, onLoad, onDelete }) => {
  return (
    <div className="seo-history-container p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="m-0">Recently Explored</h3>
        <div className="input-group" style={{ maxWidth: 300 }}>
          <span className="input-group-text bg-white border-end-0">
            <MdSearch />
          </span>
          <input 
            type="text" 
            className="form-control border-start-0 ps-0" 
            placeholder="Search URLs..." 
          />
        </div>
      </div>

      <div className="table-responsive shadow-sm rounded border">
        <table className="table table-hover align-middle mb-0">
          <thead className="bg-light">
            <tr>
              <th>Domain / URL</th>
              <th>Model</th>
              <th>User</th>
              <th>Date</th>
              <th className="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            {history.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center py-5 text-muted">
                  No analysis history found. Start by exploring a URL.
                </td>
              </tr>
            ) : (
              history.map((item) => (
                <tr key={item._id}>
                  <td>
                    <div className="fw-bold text-truncate" style={{ maxWidth: 300 }}>
                      {item.url}
                    </div>
                  </td>
                  <td>
                    <span className="badge bg-soft-info text-info">
                      {item.model}
                    </span>
                  </td>
                  <td>
                    <small className="text-muted">{item.createdByEmail}</small>
                  </td>
                  <td>
                    <small>{formatDate(item.createdAt, "dd-mm-yyyy")}</small>
                  </td>
                  <td className="text-end">
                    <button 
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => onLoad(item)}
                      title="View Report"
                    >
                      <MdOpenInNew />
                    </button>
                    <button 
                      className="btn btn-sm btn-outline-danger"
                      onClick={(e) => onDelete(item._id, e)}
                      title="Delete"
                    >
                      <MdDelete />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SEOHistoryTable;
